import {initItemcardImages} from "../../../default/global/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {init360Images} from "../../../default/global/js/init360Images";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {initHazardSection} from "../../../default/global/js/hazardSection";

import {initButtonsForIndividualization,
    checkIfIndividualizationCanBeApplied,
    selectCorrectItemBasedOnUrl} from "../../../default/global/js/individualization";

import {crossSellerCheckBoxes} from "./custom/crosssellerCheckbox";
import {showReadmoreButton} from "./custom/readmoreDescription";
import {initializeCustomSearchRadio} from "./custom/selectWithSearch";
import {sortPromotions} from "./custom/sortPromotions";
import {moveFundamentalPrice} from "./custom/moveFundamentalPrice";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    initButtonsForIndividualization();
    showReadmoreButton();
    checkIfIndividualizationCanBeApplied();
    initHazardSection();


    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item, ".js-itemcardOpenGalleryItem");
        });
    }

    crossSellerCheckBoxes();

    sortPromotions();
    moveFundamentalPrice();


    const observer = new MutationObserver(function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                const modal = document.querySelector("#individualizationModal");
                if (modal) {
                    observer.disconnect();
                    initializeCustomSearchRadio();


                    const modalHeader = document.querySelector(".individualizationModalHeader");
                    const closeButton = modalHeader.querySelector('.modal__close');
                    const modalDialog = document.querySelector(".modal__dialog:has(.individualizationModal)");

                    modalDialog.addEventListener('scroll', () => {
                        if (modalDialog.scrollTop > 0) {
                                closeButton.classList.add('is-sticky');
                            } else {
                                closeButton.classList.remove('is-sticky');
                            }
                    });
                    if (closeButton) {
                        closeButton.addEventListener('click', (event) => {
                                console.log(closeButton);

                                const overlay = document.getElementById('overlay');
                                if (overlay) {
                                    overlay.style.display = "none";
                                    overlay.style.opacity = "0";
                                }
                        });
                    }

                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
    const widget = document.querySelector('etrusted-widget');
    const container = widget.closest('.ratings');

    if(!widget || !container) return;

    container.style.display = "none";

    const observer = new MutationObserver(() => {
        if (widget.innerHTML.trim().length === 0) {
            container.style.display = "none";
        } else {
            container.style.display = "block";
        }
    });

    observer.observe(widget, { childList: true, subtree: true });

    /*const container = document.getElementById("ratings-widget");
    if(!container) return;

    setTimeout(() => {
        const hasVisibleContent = Array.from(container.childNodes).some(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;

            const excludedClasses = ["h4", "marginBottom", "marginTop"];
            const nodeClasses = node.className ? node.className.split(/\s+/) : [];
            const isExcluded = excludedClasses.every(cls => nodeClasses.includes(cls));

            if (isExcluded) return false;

            return node.textContent.trim().length > 0;
        });

        if (!hasVisibleContent) {
            container.style.display = "none";
        }
    }, 500);*/
});